import {
    uniBars,
    uniPower,
    uniEstate,
    uniTimes,
    uniReceipt,
    uniBill,
    uniNotes,
    uniBookOpen,
    uniHistory,
    uniUserCircle,
    uniSearch,
    uniTrashAlt,
    uniCommentQuestion,
    uniArrowDown,
    uniArrowUp,
} from "vue-unicons/dist/icons";

const Icons = [
    uniBars,
    uniPower,
    uniEstate,
    uniTimes,
    uniReceipt,
    uniBill,
    uniNotes,
    uniBookOpen,
    uniHistory,
    uniUserCircle,
    uniSearch,
    uniTimes,
    uniTrashAlt,
    uniCommentQuestion,
    uniArrowDown,
    uniArrowUp,
];

export default Icons;
